import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'CONTACTS';

export const {action: changeSelectedChildContact} = createAction(`${domain}/SELECTION_CHANGED`, index => index);

export const {action: edit} = createAction(`${domain}/EDIT`, () => ({}));

export const {action: cancel} = createAction(`${domain}/CANCEL`, () => ({}));

export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(`${domain}/FETCH`, (childId, withKiku, institutionId, fetchBillPayers) => ({
    childId,
    withKiku,
    institutionId,
    fetchBillPayers,
}));

export const {
    action: update,
    success: updateSuccess,
    failed: updateFailed,
} = createAction(`${domain}/UPDATE`, (data, shouldUpdateSsn, shouldUpdateAddress, ssnToken, withKiku) => ({
    data,
    shouldUpdateSsn,
    shouldUpdateAddress,
    ssnToken,
    withKiku,
}));
